import React from 'react';
// import {
// 	Route,
// 	Link
// } from 'react-router-dom';
import './examples.scss';
import { Carousel } from 'antd';
// import ajax from '@/api/public';

class Resource extends React.Component{
	constructor (props) {
		super(props)
		this.state={

		}
	}
    componentDidMount (){
        document.getElementById('app').scrollIntoView(true)
    }
	render() {
		return(
			<div className='weidai'>
				<div className='common-head home-contain'>
					<a href='#/customer' className="mianbaoxie">客户案例</a> <i className='glyphicon glyphicon-toright'></i> <span>公众号广告</span>
				</div>
				<div className='common-title' style={{marginBottom: '24px'}}>推广故事</div>
				<div className='home-contain' style={{paddingBottom: '50px'}}>
					<div className='text-center' style={{position: 'relative'}}>
						<img className='block-center' src={`${process.env.PUBLIC_URL}/images/gzh.png`} />
					</div>
				</div>
				<div className='home-contain text-contain' style={{paddingBottom:  '50px'}}>
					<span className='special'>营销痛点:</span>
					<span>地域小，同行竞争激烈，其它中国十大杰出摄影品牌</span>
					<span className='special'>期望目标:</span>
					<span>提高关注量：100个/日关注</span>
					<span className='special'>解决方案:</span>
					<span className='special'>增加广告数量，保持文案高频更新；</span>
					<span className='special'>定期更新文章，内容与文案保持一致；详情页体现时效性、技巧知识点，抓住用户痛点营销；</span>
					<span className='special'>以地域投放为基准，搭配其它基础定向及文案，进行ABtest；</span>
					<span>关注广告数据，及时调整投放方案；</span>
					<span className='special'>投放效果：</span>
					<span className='special'>关注成本：1.9元</span>
				  <span className='special'>曝光量：21万</span>
					<span>转化成本：150元/个</span>
					<span className='special'>投放总结：</span>
					<span>依附微信图文消息正文底部，获取关联曝光利用文案关注卡片形式，多创意吸引用户跳转公众号详情，多资讯曝光，增强用户粘性。</span>
				</div>
			</div>
		)
	}
}
export default Resource;



// WEBPACK FOOTER //
// ./src/components/examples/gzh.jsx